import jsPDF from 'jspdf';
import 'jspdf-autotable';
import dayjs from 'dayjs';

export const TEMPLATE_TYPES = [
    { key: 'mds_ddt', label: 'Bolla MDS (DDT)', group: 'mds' },
    { key: 'asl_richiesta_fornitura', label: 'Richiesta di fornitura ASL', group: 'asl' },
    { key: 'asl_piano_cessione', label: 'Piano di cessione ASL', group: 'asl' },
    { key: 'asl_ricevuta_consegna', label: 'Ricevuta di consegna ASL', group: 'asl' },
];

export const TEMPLATE_STATUSES = ['bozza', 'attivo', 'archiviato'];

export const getTemplateTypeLabel = (type) => {
    return TEMPLATE_TYPES.find((t) => t.key === type)?.label || type;
};

export const getTemplateTypeGroup = (type) => {
    return TEMPLATE_TYPES.find((t) => t.key === type)?.group || 'mds';
};

export const getTemplateStatusColor = (status) => {
    const colors = {
        bozza: 'default',
        attivo: 'success',
        archiviato: 'default',
    };
    return colors[status] || 'default';
};

export const getTemplateStatusLabel = (status) => {
    const labels = {
        bozza: 'Bozza',
        attivo: 'Attivo',
        archiviato: 'Archiviato',
    };
    return labels[status] || status;
};

export const DB_FIELD_CATALOG = [
    { group: 'Paziente', key: 'paziente.cognome', label: 'Cognome paziente' },
    { group: 'Paziente', key: 'paziente.nome', label: 'Nome paziente' },
    { group: 'Paziente', key: 'paziente.codice_fiscale', label: 'Codice fiscale' },
    { group: 'Paziente', key: 'paziente.data_nascita', label: 'Data di nascita' },
    { group: 'Paziente', key: 'paziente.indirizzo', label: 'Indirizzo paziente' },
    { group: 'Paziente', key: 'paziente.cap', label: 'CAP' },
    { group: 'Paziente', key: 'paziente.citta', label: 'Città' },
    { group: 'Paziente', key: 'paziente.provincia', label: 'Provincia' },
    { group: 'Dispositivo', key: 'dispositivo.modello', label: 'Modello dispositivo' },
    { group: 'Dispositivo', key: 'dispositivo.marca', label: 'Marca dispositivo' },
    { group: 'Dispositivo', key: 'dispositivo.seriale', label: 'Numero seriale' },
    { group: 'Dispositivo', key: 'dispositivo.lotto', label: 'Numero lotto' },
    { group: 'Pratica', key: 'pratica.numero', label: 'Numero pratica' },
    { group: 'Pratica', key: 'pratica.data', label: 'Data pratica' },
    { group: 'Pratica', key: 'pratica.importo_asl', label: 'Importo ASL' },
    { group: 'Pratica', key: 'pratica.importo_privato', label: 'Importo privato' },
    { group: 'Pratica', key: 'pratica.importo_totale', label: 'Importo totale' },
    { group: 'ASL', key: 'asl.nome', label: 'Nome ASL' },
    { group: 'ASL', key: 'asl.codice', label: 'Codice ASL' },
    { group: 'ASL', key: 'asl.codice_fiscale', label: 'C.F. ASL' },
    { group: 'ASL', key: 'asl.indirizzo', label: 'Indirizzo ASL' },
    { group: 'Azienda', key: 'azienda.nome', label: 'Ragione sociale' },
    { group: 'Legal entity', key: 'legal_entity.partita_iva', label: 'P.IVA azienda' },
    { group: 'Azienda', key: 'azienda.indirizzo', label: 'Indirizzo azienda' },
    { group: 'Azienda', key: 'azienda.telefono', label: 'Telefono azienda' },
    { group: 'Documento', key: 'documento.numero', label: 'Numero documento' },
    { group: 'Documento', key: 'documento.data', label: 'Data documento' },
    { group: 'Documento', key: 'documento.note', label: 'Note documento' },
];

export const TEMPLATE_FIELD_PRESETS = {
    mds_ddt: [
        { id: 'f-mds-01', label: 'Mittente – Ragione sociale', required: true, defaultValue: '', dbSource: 'azienda.nome' },
        { id: 'f-mds-02', label: 'Mittente – P.IVA', required: true, defaultValue: '', dbSource: 'legal_entity.partita_iva' },
        { id: 'f-mds-03', label: 'Mittente – Indirizzo', required: false, defaultValue: '', dbSource: 'azienda.indirizzo' },
        { id: 'f-mds-04', label: 'Mittente – Telefono', required: false, defaultValue: '', dbSource: 'azienda.telefono' },
        { id: 'f-mds-05', label: 'Destinatario – Nome ASL', required: true, defaultValue: '', dbSource: 'asl.nome' },
        { id: 'f-mds-06', label: 'Destinatario – Indirizzo ASL', required: false, defaultValue: '', dbSource: 'asl.indirizzo' },
        { id: 'f-mds-07', label: 'Paziente – Cognome', required: true, defaultValue: '', dbSource: 'paziente.cognome' },
        { id: 'f-mds-08', label: 'Paziente – Nome', required: true, defaultValue: '', dbSource: 'paziente.nome' },
        { id: 'f-mds-09', label: 'Paziente – Codice Fiscale', required: true, defaultValue: '', dbSource: 'paziente.codice_fiscale' },
        { id: 'f-mds-10', label: 'Dispositivo – Modello', required: true, defaultValue: '', dbSource: 'dispositivo.modello' },
        { id: 'f-mds-11', label: 'Dispositivo – Seriale', required: true, defaultValue: '', dbSource: 'dispositivo.seriale' },
        { id: 'f-mds-12', label: 'Dispositivo – Lotto', required: false, defaultValue: '', dbSource: 'dispositivo.lotto' },
        { id: 'f-mds-13', label: 'Documento – Numero DDT', required: true, defaultValue: '', dbSource: 'documento.numero' },
        { id: 'f-mds-14', label: 'Documento – Data', required: true, defaultValue: '', dbSource: 'documento.data' },
        { id: 'f-mds-15', label: 'Importo ASL', required: true, defaultValue: '', dbSource: 'pratica.importo_asl' },
    ],
    asl_richiesta_fornitura: [
        { id: 'f-asl-rf-01', label: 'Ente richiedente – Nome ASL', required: true, defaultValue: '', dbSource: 'asl.nome' },
        { id: 'f-asl-rf-02', label: 'Ente richiedente – C.F.', required: true, defaultValue: '', dbSource: 'asl.codice_fiscale' },
        { id: 'f-asl-rf-03', label: 'Paziente – Cognome e Nome', required: true, defaultValue: '', dbSource: 'paziente.cognome' },
        { id: 'f-asl-rf-04', label: 'Paziente – Codice Fiscale', required: true, defaultValue: '', dbSource: 'paziente.codice_fiscale' },
        { id: 'f-asl-rf-05', label: 'Paziente – Data di nascita', required: false, defaultValue: '', dbSource: 'paziente.data_nascita' },
        { id: 'f-asl-rf-06', label: 'Dispositivo – Descrizione', required: true, defaultValue: '', dbSource: 'dispositivo.modello' },
        { id: 'f-asl-rf-07', label: 'Importo richiesto', required: true, defaultValue: '', dbSource: 'pratica.importo_asl' },
        { id: 'f-asl-rf-08', label: 'Numero pratica', required: true, defaultValue: '', dbSource: 'pratica.numero' },
        { id: 'f-asl-rf-09', label: 'Data richiesta', required: true, defaultValue: '', dbSource: 'pratica.data' },
        { id: 'f-asl-rf-10', label: 'Fornitore – Ragione sociale', required: true, defaultValue: '', dbSource: 'azienda.nome' },
        { id: 'f-asl-rf-11', label: 'Fornitore – P.IVA', required: true, defaultValue: '', dbSource: 'legal_entity.partita_iva' },
    ],
    asl_piano_cessione: [
        { id: 'f-asl-pc-01', label: 'Paziente – Cognome', required: true, defaultValue: '', dbSource: 'paziente.cognome' },
        { id: 'f-asl-pc-02', label: 'Paziente – Nome', required: true, defaultValue: '', dbSource: 'paziente.nome' },
        { id: 'f-asl-pc-03', label: 'Paziente – Codice Fiscale', required: true, defaultValue: '', dbSource: 'paziente.codice_fiscale' },
        { id: 'f-asl-pc-04', label: 'Paziente – Indirizzo', required: false, defaultValue: '', dbSource: 'paziente.indirizzo' },
        { id: 'f-asl-pc-05', label: 'ASL – Nome', required: true, defaultValue: '', dbSource: 'asl.nome' },
        { id: 'f-asl-pc-06', label: 'Dispositivo – Modello', required: true, defaultValue: '', dbSource: 'dispositivo.modello' },
        { id: 'f-asl-pc-07', label: 'Dispositivo – Seriale', required: true, defaultValue: '', dbSource: 'dispositivo.seriale' },
        { id: 'f-asl-pc-08', label: 'Importo totale', required: true, defaultValue: '', dbSource: 'pratica.importo_totale' },
        { id: 'f-asl-pc-09', label: 'Importo quota ASL', required: true, defaultValue: '', dbSource: 'pratica.importo_asl' },
        { id: 'f-asl-pc-10', label: 'Importo quota privato', required: true, defaultValue: '', dbSource: 'pratica.importo_privato' },
        { id: 'f-asl-pc-11', label: 'Data cessione', required: true, defaultValue: '', dbSource: 'pratica.data' },
    ],
    asl_ricevuta_consegna: [
        { id: 'f-asl-rc-01', label: 'Paziente – Cognome e Nome', required: true, defaultValue: '', dbSource: 'paziente.cognome' },
        { id: 'f-asl-rc-02', label: 'Paziente – Codice Fiscale', required: true, defaultValue: '', dbSource: 'paziente.codice_fiscale' },
        { id: 'f-asl-rc-03', label: 'Dispositivo – Modello', required: true, defaultValue: '', dbSource: 'dispositivo.modello' },
        { id: 'f-asl-rc-04', label: 'Dispositivo – Seriale', required: true, defaultValue: '', dbSource: 'dispositivo.seriale' },
        { id: 'f-asl-rc-05', label: 'Data consegna', required: true, defaultValue: '', dbSource: 'documento.data' },
        { id: 'f-asl-rc-06', label: 'Firma paziente (testo ricevuta)', required: false, defaultValue: 'Il sottoscritto dichiara di aver ricevuto quanto indicato', dbSource: null },
        { id: 'f-asl-rc-07', label: 'Fornitore – Ragione sociale', required: true, defaultValue: '', dbSource: 'azienda.nome' },
        { id: 'f-asl-rc-08', label: 'ASL – Nome', required: true, defaultValue: '', dbSource: 'asl.nome' },
    ],
};

const MOCK_FIELD_VALUES = {
    'paziente.cognome': 'Ferraro',
    'paziente.nome': 'Carlo',
    'paziente.codice_fiscale': 'FRRCRL80A01F839P',
    'paziente.data_nascita': '01/01/1980',
    'paziente.indirizzo': 'Via Roma 10',
    'paziente.cap': '84100',
    'paziente.citta': 'Salerno',
    'paziente.provincia': 'SA',
    'dispositivo.modello': 'Oticon Real 1 miniRITE',
    'dispositivo.marca': 'Oticon',
    'dispositivo.seriale': 'SN-2024-00912',
    'dispositivo.lotto': 'L-2024-091',
    'pratica.numero': 'PRAT-ASL-MED-001',
    'pratica.data': dayjs().format('DD/MM/YYYY'),
    'pratica.importo_asl': '€ 1.151,00',
    'pratica.importo_privato': '€ 349,00',
    'pratica.importo_totale': '€ 1.500,00',
    'asl.nome': 'ASL Salerno 1',
    'asl.codice': 'SA1',
    'asl.codice_fiscale': '02345678901',
    'asl.indirizzo': 'Via Nizza 146 – 84124 Salerno',
    'azienda.nome': 'CEAS di MATRONE ANGELO S.R.L. Unipersonale',
    'legal_entity.partita_iva': 'IT04567890655',
    'azienda.indirizzo': 'Via Posidonia 171 – 84128 Salerno',
    'azienda.telefono': '089 241234',
    'documento.numero': 'DDT-2024-0081',
    'documento.data': dayjs().format('DD/MM/YYYY'),
    'documento.note': '',
};

const resolveFieldValue = (mapping) => {
    if (mapping.dbSource && MOCK_FIELD_VALUES[mapping.dbSource]) {
        return MOCK_FIELD_VALUES[mapping.dbSource];
    }
    return mapping.defaultValue || `[${mapping.label}]`;
};

export const generateTemplatePreviewPdf = (template) => {
    const doc = new jsPDF('p', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 15;
    const contentWidth = pageWidth - margin * 2;

    const fieldMap = {};
    (template.fieldMappings || []).forEach((m) => {
        fieldMap[m.id] = resolveFieldValue(m);
    });

    const getMapped = (id) => fieldMap[id] || '';

    doc.setFontSize(8);
    doc.setTextColor(150, 150, 150);
    doc.text('ANTEPRIMA – dati di esempio – non valida come documento ufficiale', pageWidth / 2, 8, { align: 'center' });

    let y = 16;

    const drawHeader = (title) => {
        doc.setFillColor(240, 240, 240);
        doc.rect(margin, y, contentWidth, 8, 'F');
        doc.setFontSize(11);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(30, 30, 30);
        doc.text(title, margin + 3, y + 5.5);
        y += 12;
    };

    const drawRow = (label, value) => {
        doc.setFontSize(9);
        doc.setFont('helvetica', 'bold');
        doc.setTextColor(80, 80, 80);
        doc.text(label + ':', margin, y);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(20, 20, 20);
        doc.text(value || '—', margin + 55, y);
        y += 6;
    };

    const drawDivider = () => {
        doc.setDrawColor(200, 200, 200);
        doc.line(margin, y, margin + contentWidth, y);
        y += 4;
    };

    if (template.type === 'mds_ddt') {
        drawHeader(`DOCUMENTO DI TRASPORTO (Bolla MDS)  –  ${getMapped('f-mds-13') || 'N° documento'}`);
        drawRow('Data', getMapped('f-mds-14'));
        drawDivider();

        drawHeader('MITTENTE');
        drawRow('Ragione sociale', getMapped('f-mds-01'));
        drawRow('P.IVA', getMapped('f-mds-02'));
        drawRow('Indirizzo', getMapped('f-mds-03'));
        drawRow('Telefono', getMapped('f-mds-04'));
        drawDivider();

        drawHeader('DESTINATARIO (ASL)');
        drawRow('Nome ASL', getMapped('f-mds-05'));
        drawRow('Indirizzo', getMapped('f-mds-06'));
        drawDivider();

        drawHeader('PAZIENTE');
        drawRow('Cognome', getMapped('f-mds-07'));
        drawRow('Nome', getMapped('f-mds-08'));
        drawRow('Codice Fiscale', getMapped('f-mds-09'));
        drawDivider();

        drawHeader('ARTICOLO / DISPOSITIVO');
        doc.autoTable({
            startY: y,
            margin: { left: margin, right: margin },
            head: [['Modello', 'N° Seriale', 'Lotto', 'Importo ASL']],
            body: [[getMapped('f-mds-10'), getMapped('f-mds-11'), getMapped('f-mds-12'), getMapped('f-mds-15')]],
            theme: 'grid',
            headStyles: { fillColor: [220, 220, 220], textColor: [30, 30, 30], fontSize: 9 },
            bodyStyles: { fontSize: 9 },
        });
        y = doc.lastAutoTable.finalY + 8;

        doc.setFontSize(7.5);
        doc.setTextColor(100, 100, 100);
        doc.text(
            'Dispositivo medico ai sensi del Reg. UE 2017/745 – Spesa detraibile ai sensi dell\'art. 15, co.1, lett. c) TUIR',
            margin, y
        );
    } else if (template.type === 'asl_richiesta_fornitura') {
        drawHeader('RICHIESTA DI FORNITURA ASL');
        drawRow('ASL richiedente', getMapped('f-asl-rf-01'));
        drawRow('C.F. ASL', getMapped('f-asl-rf-02'));
        drawRow('N° pratica', getMapped('f-asl-rf-08'));
        drawRow('Data richiesta', getMapped('f-asl-rf-09'));
        drawDivider();

        drawHeader('PAZIENTE');
        drawRow('Cognome e Nome', getMapped('f-asl-rf-03'));
        drawRow('Codice Fiscale', getMapped('f-asl-rf-04'));
        drawRow('Data di nascita', getMapped('f-asl-rf-05'));
        drawDivider();

        drawHeader('DISPOSITIVO RICHIESTO');
        drawRow('Descrizione', getMapped('f-asl-rf-06'));
        drawRow('Importo richiesto', getMapped('f-asl-rf-07'));
        drawDivider();

        drawHeader('FORNITORE');
        drawRow('Ragione sociale', getMapped('f-asl-rf-10'));
        drawRow('P.IVA', getMapped('f-asl-rf-11'));
    } else if (template.type === 'asl_piano_cessione') {
        drawHeader('PIANO DI CESSIONE ASL');
        drawRow('ASL', getMapped('f-asl-pc-05'));
        drawRow('Data cessione', getMapped('f-asl-pc-11'));
        drawDivider();

        drawHeader('PAZIENTE');
        drawRow('Cognome', getMapped('f-asl-pc-01'));
        drawRow('Nome', getMapped('f-asl-pc-02'));
        drawRow('Codice Fiscale', getMapped('f-asl-pc-03'));
        drawRow('Indirizzo', getMapped('f-asl-pc-04'));
        drawDivider();

        drawHeader('DISPOSITIVO');
        drawRow('Modello', getMapped('f-asl-pc-06'));
        drawRow('N° Seriale', getMapped('f-asl-pc-07'));
        drawDivider();

        drawHeader('IMPORTI');
        drawRow('Totale', getMapped('f-asl-pc-08'));
        drawRow('Quota ASL', getMapped('f-asl-pc-09'));
        drawRow('Quota privato', getMapped('f-asl-pc-10'));
    } else if (template.type === 'asl_ricevuta_consegna') {
        drawHeader('RICEVUTA DI CONSEGNA ASL');
        drawRow('Data consegna', getMapped('f-asl-rc-05'));
        drawRow('ASL', getMapped('f-asl-rc-08'));
        drawRow('Fornitore', getMapped('f-asl-rc-07'));
        drawDivider();

        drawHeader('PAZIENTE');
        drawRow('Cognome e Nome', getMapped('f-asl-rc-01'));
        drawRow('Codice Fiscale', getMapped('f-asl-rc-02'));
        drawDivider();

        drawHeader('DISPOSITIVO CONSEGNATO');
        drawRow('Modello', getMapped('f-asl-rc-03'));
        drawRow('N° Seriale', getMapped('f-asl-rc-04'));
        drawDivider();

        y += 6;
        doc.setFontSize(9);
        doc.setFont('helvetica', 'italic');
        doc.setTextColor(60, 60, 60);
        const dichiarazione = getMapped('f-asl-rc-06');
        doc.text(dichiarazione, margin, y, { maxWidth: contentWidth });
        y += 16;

        doc.setDrawColor(60, 60, 60);
        doc.line(margin, y, margin + 60, y);
        doc.setFontSize(8);
        doc.setFont('helvetica', 'normal');
        doc.setTextColor(80, 80, 80);
        doc.text('Firma paziente', margin, y + 4);
    } else {
        drawHeader(template.name || 'Modello senza tipo');
        (template.fieldMappings || []).forEach((m) => {
            drawRow(m.label, resolveFieldValue(m));
        });
    }

    doc.setFontSize(7);
    doc.setTextColor(170, 170, 170);
    doc.text(`Generato da MedicalStudio – ${dayjs().format('DD/MM/YYYY HH:mm')}`, pageWidth / 2, 290, { align: 'center' });

    return doc.output('bloburl');
};

export const recalculateTemplateEditorWorkspace = (workspace) => {
    if (!workspace) return workspace;
    const templates = workspace.templates || [];
    return {
        ...workspace,
        summary: {
            total: templates.length,
            attivi: templates.filter((t) => t.status === 'attivo').length,
            bozze: templates.filter((t) => t.status === 'bozza').length,
            archiviati: templates.filter((t) => t.status === 'archiviato').length,
            mds: templates.filter((t) => getTemplateTypeGroup(t.type) === 'mds').length,
            asl: templates.filter((t) => getTemplateTypeGroup(t.type) === 'asl').length,
        },
    };
};
